import { useEffect, useState } from 'react';
import '../assets/css/card.css';
import seleccionador from '../assets/img/gif/_seleccionador.gif'
import progress from '../assets/img/gif/progres.gif'
import '../assets/css/drawer.css';





function Progress(props) {
    function moneda(number) {
        const formattedNumber = number.toLocaleString('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2,
        });

        return formattedNumber;
    }
    useEffect(() => {

    });
    return (
        <div class="row-card" name={props.rwid}>
            <div class="card-">
                <div class="row center-v">
                    <div class="col-3">
                        <div class="prev">
                            <img src={props.Prev}></img>
                        </div>
                    </div>
                    <div class="col-9">
                        <div class="desc">
                            <div class="item">
                                <p style={{fontSize:14}}>{props.Descripcion}</p>
                            </div>
                            <div class="item precio">
                                <p style={{fontSize:14}}>{moneda(props.Precio)}</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



        </div>

    );
}

export default Progress;